export default function GlobalLoader({
  message = 'Agent Loop is on the case…',
}: {
  message?: string;
}) {
  return (
    <div className="global-loader">
      {/* Fox mascot, running with magnifying glass */}
      <img
        src="/images/mascot/fox-investigating.png"
        alt=""
        className="global-loader-fox"
      />


      {/* Message */}
      {message && (
        <p className="global-loader-message">{message}</p>
      )}

      {/* Animated magnifying glass dots */}
      <div className="global-loader-dots">
        <span className="global-loader-dot" />
        <span className="global-loader-dot" />
        <span className="global-loader-dot" />
      </div>

      <style>{`
        .global-loader {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(180deg, #F1EDE3 0%, #FAF9F6 40%, #ffffff 70%);
          gap: 12px;
        }

        .global-loader-fox {
          width: 120px;
          height: auto;
          object-fit: contain;
          animation: foxRun 1.6s ease-in-out infinite;
          filter: drop-shadow(0 4px 12px rgba(14, 21, 48, 0.12));
        }

        @keyframes foxRun {
          0%, 100% { transform: translateX(0) translateY(0); }
          25% { transform: translateX(8px) translateY(-5px); }
          50% { transform: translateX(0) translateY(0); }
          75% { transform: translateX(-8px) translateY(-5px); }
        }

        .global-loader-logo {
          display: block;
          height: 28px;
          width: auto;
          object-fit: contain;
          margin-top: 4px;
        }

        .global-loader-message {
          margin: 0;
          font-family: 'DM Sans', system-ui, -apple-system, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #7A7E94;
          letter-spacing: 0.01em;
        }

        .global-loader-dots {
          display: flex;
          gap: 8px;
          align-items: center;
          margin-top: 4px;
        }

        .global-loader-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #E97A50;
          opacity: 0.3;
          animation: loaderPulse 1.2s ease-in-out infinite;
        }

        .global-loader-dot:nth-child(2) {
          animation-delay: 0.15s;
        }

        .global-loader-dot:nth-child(3) {
          animation-delay: 0.3s;
        }

        @keyframes loaderPulse {
          0%, 60%, 100% {
            opacity: 0.2;
            transform: scale(1);
          }
          30% {
            opacity: 1;
            transform: scale(1.3);
          }
        }
      `}</style>
    </div>
  );
}
